import moment from "moment";

const heuteIso = () => moment().format("YYYY-MM-DD");

// Zeitraum des gewählten Presets; null bei custom (dort gilt die Validierung).

// Mit „Überfällige ausschließen“ (Haken an, Default) startet jedes Preset bei

// heute — Personen mit Frist vor heute fehlen im Export; ohne Haken wird nur

// die Ober-/Untergrenze gesendet, überfällige Personen wandern mit.

export function zeitraumVonPreset(auswahl) {

  const untergrenze = auswahl.ueberfaelligeAusschliessen

    ? { from: heuteIso() }

    : {};

  if (auswahl.preset === "heute") {

    return { ...untergrenze, to: heuteIso() };

  }

  if (auswahl.preset === "p4") {

    return { ...untergrenze, to: moment().add(28, "days").format("YYYY-MM-DD") };

  }

  if (auswahl.preset === "p6") {

    return { ...untergrenze, to: moment().add(42, "days").format("YYYY-MM-DD") };

  }

  return null;

}

// Fenster-Params einzeln in die Query: Presets mit „Überfällige“ senden nur
// die Ober-/Untergrenze — das Backend akzeptiert from/to auch einseitig
export function zeitraumQueryFenster(zeitraum) {
  if (!zeitraum) return {};
  const fenster = {};
  if (zeitraum.from) fenster.from = zeitraum.from;
  if (zeitraum.to) fenster.to = zeitraum.to;
  return fenster;
}